var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.51485 7.01118L10.3333 3.23241C11.3803 2.23731 13.1019 2.25857 14.1777 3.28179C15.2536 4.30432 15.2766 5.94064 14.2297 6.93574L12.8515 8.32312M2.92586 10.877C2.55787 11.2268 1.79663 11.9263 1.79663 11.9263C0.748937 12.9214 0.720075 14.6956 1.79663 15.7188C2.87174 16.7407 4.59336 16.7633 5.64105 15.7675L9.36714 12.5525",
    stroke: "#53237F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.7684 10.4032C6.32095 9.91965 6.05022 9.27582 6.00657 8.59145C5.98077 8.20753 6.03117 7.82206 6.15437 7.46119C6.27756 7.10031 6.47066 6.77246 6.72057 6.49988M9.23238 8.59585C10.2367 9.68816 10.2583 11.4361 9.28088 12.4999",
    stroke: "#53237F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/shareIcon.c59876b2519113b34ae65104f6790708.svg";
export { ForwardRef as ReactComponent };